export default {
    data () {
        return {
            apiEndPoints : {
                registerUser : '/register',
                forgotPassword: '/forgot-password',
                resetPassword: '/reset-password',
                registerCard: '/enroll',
                activateOffer: '/activate',
                matchedOffers: '/matchedoffers',
                enrollAndActivate: '/enrollAndActivate',
                getAllCategories: '/getAllCategories',
                getTransactionHistory: '/getTransactionHistory',
                getChartData: '/getChartData',
                changePassword: '/changePassword',
                changeEmail: '/changeEmail',
                getPreLoginFeaturedOffers: '/getPreLoginFeaturedOffers',
                emailActivateOffer: '/email_offer_activation',
                getMatchedOfferForEmailActivation: '/getMatchedOfferForEmailActivation',
                getCampaignOffer: '/getCampaignOffer',
                activateCampaignOffer: '/activateCampaignOffer',
                campaignEnrollAndActivate: '/campaignEnrollAndActivate',

            }
    }
    },
    // created: function () {
    //     console.log('Printing from the Mixin');
    // },
    methods: {
        validateEmailInput(email) {
            let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return reg.test(email);
        },

        resetUserInLocalStorage(user) {
            localStorage.removeItem('user_obj');
            localStorage.setItem('user_obj', JSON.stringify(user));
        },
        getUser() {
            axios.get('/get-user', {})
                .then(response => {
                    // console.log(response, 'user_obj');
                    if(response.data && response.data.data && response.data.data.id) {
                        this.resetUserInLocalStorage(response.data.data);
                        return response.data.data;
                    }
                }).catch(error => {

                if (error.response && error.response.status && (error.response.status == 401 || error.response.status == 419)) {

                }

                return false;
            });
        },
        beforeEachRoute: function(router) {


            localStorage.removeItem('user_obj');

            router.beforeEach(async (to, from, next) => {
                let authenticated = false;
                /**
                 * set page title
                 */
                document.title = to.meta.title;

                /**
                 * For email-activation view, we only deal with bcn in url params.
                 * dont get user.
                 */
                if(to.name == 'email-activation' || to.name == 'campaign') {
                    next();
                    return;
                }

                await axios.get('/get-user', {})
                    .then(response => {
                        // console.log('then  await');
                        if(response.data && response.data.data && response.data.data.id) {
                            authenticated =  true;
                            localStorage.setItem('user_obj', JSON.stringify(response.data.data));
                        }
                    }).catch(error => {

                        // if (error.response && error.response.status && error.response.status == 401) {
                        //
                        // }
                        authenticated =  false;
                    });

                if (authenticated) {

                    if (to.name == 'sign_in' || to.name == 'register' || to.name == 'landing') {
                          router.push({ name: 'offers' });
                    } else {
                        next();
                    }
                } else {
                    if (to.matched.some(record => record.meta.requiresAuth)) {
                        router.push({ name: 'sign_in' });
                    } else {
                         next();
                    }
                }
            });
        }
    }
};


